// lib/backdrop/backdrop.tsx
import {
  CircularProgress,
  Backdrop as MuiBackdrop
} from "@mui/material";
import { jsx } from "react/jsx-runtime";
var backdropStyle = {
  color: "#fff",
  zIndex: (theme) => theme.zIndex.drawer + 1
};
var Backdrop = ({ open }) => /* @__PURE__ */ jsx(MuiBackdrop, { sx: backdropStyle, open, children: /* @__PURE__ */ jsx(CircularProgress, { color: "inherit" }) });
export {
  Backdrop
};
